import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import UpdateAnimationRequest from '../../../Spirit/Admin/Interfaces/Models/AnimationService/UpdateAnimationRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import AnimationResponse from '../../../Spirit/Admin/Interfaces/Models/AnimationService/AnimationResponse';

export default class AnimationService {
	webApiService: WebApiService;
	DeleteAnimationEvent = new Events<WsResponseModelT<Boolean>>();
	GetAnimationsEvent = new Events<WsResponseModelT<Array<AnimationResponse>>>();
	UpdateAnimationEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('AnimationService', 'DeleteAnimation', (res: WsResponseModelT<Boolean>) => {
			self.DeleteAnimationEvent.trigger(res);
		});
		webApiService.on('AnimationService', 'GetAnimations', (res: WsResponseModelT<Array<AnimationResponse>>) => {
			self.GetAnimationsEvent.trigger(res);
		});
		webApiService.on('AnimationService', 'UpdateAnimation', (res: WsResponseModelT<Boolean>) => {
			self.UpdateAnimationEvent.trigger(res);
		});
	}
	DeleteAnimation(id: string = '') { 	
        this.webApiService.send('AnimationService', 'DeleteAnimation' , id);
    }
	GetAnimations() { 	
        this.webApiService.send('AnimationService', 'GetAnimations' );
    }
	UpdateAnimation(request: UpdateAnimationRequest = null) { 	
        this.webApiService.send('AnimationService', 'UpdateAnimation' , request);
    }
	 // async methods
	async deleteAnimationAsync(id: string = ''): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.DeleteAnimation.bind(this), this.DeleteAnimationEvent)(id);
	}
	async getAnimationsAsync(): Promise<Array<AnimationResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetAnimations.bind(this), this.GetAnimationsEvent)();
	}
	async updateAnimationAsync(request: UpdateAnimationRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.UpdateAnimation.bind(this), this.UpdateAnimationEvent)(request);
	}
}